import create from "zustand";

interface ModalState {
  id: string | null;
  classe: string | null;
  isOpen: boolean;
  isEditing: boolean;
  isDeleting: boolean;
  isOperacoesOpen: boolean;
  setId: (args: string | null) => void;
  setClasse: (args: string) => void;
  setIsOpen: (args: boolean) => void;
  setIsEditing: (args: boolean) => void;
  setIsDeleting: (args: boolean) => void;
  setIsOperacoesOpen: (args: boolean) => void;
}

const useModal = create<ModalState>((set) => ({
  id: null,
  classe: null,
  isOpen: false,
  isEditing: false,
  isDeleting: false,
  isOperacoesOpen: false,
  setId: (id) => {
    set(state => ({ id }));
  },
  setClasse: (classe) => {
    set(state => ({ classe }));
  },
  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },
  setIsEditing: (isEditing) => {
    set(state => ({ isEditing }));
  },
  setIsDeleting: (isDeleting) => {
    set(state => ({ isDeleting }));
  },
  setIsOperacoesOpen: (isOperacoesOpen) => {
    set(state => ({ isOperacoesOpen }));
  },
}));

export default useModal;
